import { animationFrameScheduler, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from '@angular/cdk/layout';
import {
  distinctUntilChanged,
  map,
  observeOn,
  share,
  shareReplay,
  startWith,
} from 'rxjs/operators';

@Injectable()
export class ScreenService {
  private _changed: Observable<BreakpointState>;
  private _isMobileObservable: Observable<boolean>;

  get changed() {
    if (!this._changed) {
      this._changed = this.breakpointObserver
        .observe([
          Breakpoints.XSmall,
          Breakpoints.Small,
          Breakpoints.Medium,
          Breakpoints.Large,
        ])
        .pipe(
          shareReplay({
            bufferSize: 1,
            refCount: true,
          }),
          observeOn(animationFrameScheduler)
        );
    }
    return this._changed;
  }

  constructor(private breakpointObserver: BreakpointObserver) {}

  observeIsMobile() {
    if (!this._isMobileObservable) {
      this._isMobileObservable = this.changed.pipe(
        map(() => this.isMobileScreen()),
        startWith(this.isMobileScreen()),
        distinctUntilChanged(),
        shareReplay({
          bufferSize: 1,
          refCount: true,
        })
      );
    }

    return this._isMobileObservable;
  }

  isMobileScreen() {
    const isSmall = this.breakpointObserver.isMatched(Breakpoints.Small);
    return isSmall || this.breakpointObserver.isMatched(Breakpoints.XSmall);
  }

  isHandsetLandscape() {
    return this.breakpointObserver.isMatched(Breakpoints.HandsetLandscape);
  }
}
